import type { StatsSnapshot } from './gameplay-snapshot';
import { useCurrencyStore } from '../store/zustand/useCurrencyStore';
import { CONFIG } from '../config';
import { multiplyAll } from '@game-libs/exc-libs/src/helpers/array.helpers';
import { unitStats as stats } from './index';

export const updateWizardStats = (state: StatsSnapshot) => {
  const upgrades = state.upgrades.wizard;
  const wizard = state.generators.wizard;
  const currency = useCurrencyStore.getState();

  if (currency.mana <= 0) {
    stats.wizard = { mainIndividualGenerationStat: 0, damagePerTick: 0, goldGeneration: 0 };

    return;
  }

  const baseDamage = wizard.baseGeneration + upgrades.archimage.multiplier;

  const manaBoostMultiplier = currency.mana > upgrades.manaBoost.multiplier ? 2 : 1;

  const inspirationMultiplier = currency.inspiration.remainingActive > 0 ? currency.inspiration.multiplier : 1;
  const damageMultiplier = multiplyAll([manaBoostMultiplier, upgrades.magicMissile.multiplier, inspirationMultiplier]);

  const criticalChance = upgrades.weatherForecast?.multiplier ?? 0;
  const criticalMultiplier = upgrades.lightningStrike?.multiplier ?? 1;

  const goldMultiplier = multiplyAll([upgrades.silverStaff.multiplier, upgrades.goldenStaff.multiplier]);

  const damagePerTick = baseDamage * damageMultiplier * wizard.owned;

  const goldGeneration = damagePerTick * CONFIG.game.goldPerDamage * goldMultiplier;

  // const inspirationGeneration = sumAll([]);
  stats.wizard = {
    mainIndividualGenerationStat: baseDamage * damageMultiplier,
    damagePerTick,
    goldGeneration,
    criticalChance,
    criticalDamage: criticalMultiplier * damagePerTick,
    // inspirationGeneration,
  };
};
